import { useQuery } from '@tanstack/react-query'

import { defaultApiHost } from '@src/helpers'

import { handleResponse } from '../services/rest/apiService'
import type { Appointment } from '../services/rest/types'

/**
 * Hook to fetch appointment details.
 */
export const useAppointmentQuery = (
  chatChannelId: string | undefined,
  appointmentId: string | undefined,
  visitorId: string | undefined,
  apiHost = defaultApiHost,
) => {
  const query = useQuery<Appointment>({
    queryKey: [
      'getAppointment',
      { chatChannelId, apiHost, appointmentId, visitorId },
    ],
    queryFn: async () => {
      const response = await fetch(
        `${apiHost}/api/chat_channels/${chatChannelId}/appointments/${appointmentId}?visitor_id=${visitorId}`,
      )
      return handleResponse(response)
    },
    retry: false,
    enabled: !!chatChannelId && !!appointmentId,
  })

  return query
}
